import { render } from "./MainLobby.vue?vue&type=template&id=5b6503de&scoped=true"
import script from "./MainLobby.vue?vue&type=script&lang=js"
export * from "./MainLobby.vue?vue&type=script&lang=js"

import "./MainLobby.vue?vue&type=style&index=0&id=5b6503de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6503de"]])

export default __exports__